import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CmsIconListComponent } from '@domgen/dgx-fe-cms';
import { Theme } from '@domgen/dgx-fe-common';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import { PanelBorderRadius } from '@domgen/dgx-fe-components/panel/lib/models/panel-border-radius.type';
import {
  CmsApplianceDetailsSteppedBenefitsPanel,
  RegistrationTestHooks,
} from '@us-registration/util-models';

@Component({
  standalone: true,
  selector: 'us-registration-appliance-stepped-benefits-panel',
  templateUrl: './appliance-details-stepped-benefits-panel.component.html',
  styleUrls: ['./appliance-details-stepped-benefits-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CmsIconListComponent, NgIf, PanelComponent, TestHookDirective],
})
export class ApplianceDetailsSteppedBenefitsPanelComponent {
  testHooks = RegistrationTestHooks;

  @Input() benefitsPanel?: CmsApplianceDetailsSteppedBenefitsPanel;
  @Input() rounded: PanelBorderRadius = 'lg';
  @Input() variant: Theme = 'background-alternative';
}
